<template>
  <div class="flex items-center justify-between bg-primary-500 px-4 py-3">
    <div class="flex items-center gap-2">
      <div class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-white">
        <img
          :src="ziggy_laptop"
          alt="Ziggy"
          class="h-7 w-7 object-contain"
        />
      </div>
      <div>
        <div class="flex items-center gap-1.5">
          <p class="text-sm font-semibold text-white">{{ $t('ai.assistant.name') }}</p>
          <span
            class="rounded-full bg-gray-200 px-1.5 py-0.5 text-[10px] leading-none font-medium text-gray-600 uppercase"
            >beta</span
          >
        </div>
        <p class="text-xs text-white/70">{{ context_label }}</p>
      </div>
    </div>
    <div class="flex items-center gap-1">
      <button
        :class="[
          'rounded-full p-1.5 transition hover:bg-white/10',
          show_history ? 'bg-white/20 text-white' : 'text-white/70 hover:text-white',
        ]"
        @click="$emit('toggle_history')"
      >
        <FontAwesomeIcon
          :icon="['far', 'clock-rotate-left']"
          class="text-xs"
        />
      </button>
      <button
        class="rounded-full p-1.5 text-white/70 transition hover:bg-white/10 hover:text-white"
        @click="$emit('clear')"
      >
        <FontAwesomeIcon
          icon="plus"
          class="text-xs"
        />
      </button>
      <button
        class="rounded-full p-1.5 text-white/70 transition hover:bg-white/10 hover:text-white"
        @click="$emit('toggle_fullscreen')"
      >
        <FontAwesomeIcon
          :icon="is_fullscreen ? 'compress' : 'expand'"
          class="text-xs"
        />
      </button>
    </div>
  </div>
</template>

<script setup>
import ziggy_laptop from '@/assets/images/ziggy/Ziggy_laptop.png';

const props = defineProps({
  context_label: { type: String, required: true },
  show_history: { type: Boolean, required: true },
  is_fullscreen: { type: Boolean, required: true },
});

const emits = defineEmits(['clear', 'toggle_history', 'toggle_fullscreen']);
</script>
